//@flow

import React from 'react'
import { connect } from 'react-redux'
import parseDate from 'date-fns/parse'

import { selectCurrentUser } from '../../../stores/currentUser'
import { getArticles } from '../../../stores/automation/articleStore'
import { fetchAutomationArticles } from '../../../sagas/automation/fetchAutomationArticles'
import { POLL_PREVIEW_URL } from '../../../urls'
type Props = {
  articles: [],
  user: Object,
  fetchAutomationArticles: Function,
}

class Articles extends React.Component<Props> {
  componentWillMount() {
    const { user, fetchAutomationArticles } = this.props
    fetchAutomationArticles(user.customerId)
  }

  render() {
    const { user, articles } = this.props
    const rowClasses =
      'bg-white gray h3 f6 ph4 flex items-center bt b--moon-gray hover-bg-near-white'

    const renderArticles = articles => {
      if (!articles) {
        return <div className={rowClasses}>Loading...</div>
      }
      if (articles.length < 1) {
        return (
          <div className={rowClasses}>
            No articles haves been automatically matched yet.
          </div>
        )
      }
      return articles.map((article, i) => {
        const createdAt = parseDate(article.createdAt)
        return (
          <div className={rowClasses} key={i}>
            <div className="dtc tl w-40 word-wrap v-mid pa2">
              <div className="di pointer hover-op-con-dark underline-hover relative ">
                <a href={article.url}>{article.url}</a>
              </div>
            </div>
            <div className="dtc tl w-40 word-wrap v-mid pa2">
              <div className="di  hover-op-con-dark relative ">
                <a
                  href={`${POLL_PREVIEW_URL}/${user.customerId}/${article.pollID}`}
                >
                  {article.pollHeader}
                </a>
              </div>
            </div>
            <div
              className="dtc w-15 center v-mid pa2"
              title={'created ' + createdAt.toLocaleString()}
            >
              {createdAt.getDate() +
                '.' +
                (createdAt.getMonth() + 1) +
                '.' +
                createdAt.getFullYear()}
            </div>
          </div>
        )
      })
    }

    return (
      <section>
        <div className="word-wrap dt-row w-100 bg-op-con-dark white">
          <div className="dtc tc w-5 v-mid pa2">URL</div>
          <div className="dtc tc w-5 v-mid pa2">Poll Embedded</div>
          <div className="dtc tc w-5 v-mid pa2">Date</div>
        </div>
        {renderArticles(articles)}
      </section>
    )
  }
}

const mapStateToProps = state => ({
  articles: getArticles(state),
  user: selectCurrentUser(state),
})

const mapDispatchToProps = dispatch => ({
  fetchAutomationArticles: customerId =>
    dispatch(fetchAutomationArticles(customerId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Articles)



// WEBPACK FOOTER //
// ./src/components/Pages/Automation/Articles.js